import React from 'react';
import { TableCellPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { InboundTableCellStyled, TableCellStyled } from './styles';

interface Props extends TableCellPropsType {
  isInbound?: boolean;
}

const DashboardTableCell: React.FC<Props> = (props) => {
  const { isInbound, ...rest } = props;
  return isInbound ? <InboundTableCellStyled {...rest} /> : <TableCellStyled {...rest} />;
};

export default DashboardTableCell;
